import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
import { logUI } from "../../api/andyliticsApi";
import { Typography, LinkText, Divider, Checkbox } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomeSplitLayout } from "./layout"
import RecipientSelect from './RecipientSelect';
import InHomeConfirmationModal from './InHomeConfirmationModal';

const InHomeWho = ({ history, profileList, selectedUsers, getPrefilledData, cancelBooking, serviceLocation, setSelectedUsers }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Displayed`, new Date(), Tools.getURLPath());
        populatePreCheckedRecipientSelect();
    }, []);

    const [userList, setUserList] = useState([]);

    const populatePreCheckedRecipientSelect = () => {
        const userList = createUserList();
        if (selectedUsers?.length) {
            selectedUsers.forEach((u) => {
                if (u.isChecked) {
                    userList.forEach(ep => {
                        if (u.mrn === ep.mrn) {
                            ep.isChecked = true;
                        }
                    })
                }
            })
        }
        setUserList(userList);
    }


    const createUserList = () => {
        return profileList.map((prof, i) => {
            let inHomeProfile = {
                patientName: prof.patient?.PatientName,
                firstName: prof.patient?.FirstName,
                lastName: prof.patient?.LastName,
                dob: prof.patient?.DOB,
                mrn: prof.patient?.AMRN,
                eligibleVaccines: [],
                eligible: false,
            }
            let vaxFeature = prof.features.find((feature) => feature.key === "inHomeVaccination")
            if (vaxFeature) {
                inHomeProfile.eligible = true;
                inHomeProfile.eligibleVaccines = vaxFeature.vaccinations;
            }
            return inHomeProfile;
        });
    }

    const handleCheck = (index) => {
        let temp = [...userList];
        temp[index].isChecked = !temp[index].isChecked
        setUserList(temp);
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Next.Clicked`, new Date(), Tools.getURLPath());
        let selectedUsers = userList.filter((u, i) => {
            return u.isChecked
        })
        if (selectedUsers.length) {
            setSelectedUsers(selectedUsers);
            history.push("/inhomeschedule/s31")
        } 

    }

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Previous.Clicked`, new Date(), Tools.getURLPath());
        history.push("/inhomeschedules")
    }
    const anyCheckedUser = userList?.find((user) => {
        return !!user.isChecked
    });
    const disabledNext = !anyCheckedUser;

    return (
        <>
            {(!serviceLocation) ? <Redirect to='/inhomeschedules' /> : 
                <InHomeSplitLayout
                    className="inhome-scheduling-who-container"
                    progressPercent={2 / 7 * 100}
                >
                    <InHomeMainPanel
                        heading="Who will be receiving the vaccinations?"
                        schedulingButtons={{
                            disabledNext: disabledNext,
                            leftOnClick: onClickPrevious,
                            rightOnClick: onClickNext
                        }}
                    >
                        <div className="row">
                            <div className="col-12 col-lg-10 who-select-detail">
                                {/* Recipients selection screen*/}
                                <RecipientSelect userList={userList} handleCheck={handleCheck} />

                                <InHomeConfirmationModal />

                            </div>
                        </div>

                    </InHomeMainPanel>

                    <InHomeOverviewPanel recipientsPhase={true} />
                </InHomeSplitLayout>
            }
        </>
    );
}

const mapStateToProps = state => {
    return {
        profileList: state.memberships.profileList,
        serviceLocation: state.inHome.serviceLocationContactInfo,
        selectedUsers: state.inHome.selectedUsers,
        engageHelpDeskNumber: state.session.serverData?.engageHelpDeskNumber || '833.466.3020',
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPrefilledData: (selectedUsers) => {
            dispatch({ type: types.CHECK_GET_INHOME_PREFILL, selectedUsers });
        },
        cancelBooking: () => {
            dispatch({ type: types.CANCEL_INHOME_BOOKING });
        },
        setSelectedUsers: (users) => {
            dispatch({ type: types.SET_SELECTED_USERS, selectedUsers: users })
        },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWho);